var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.28689",
      "conversations-internal-schema": "static-1.13628",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8513",
      "hubspot-url-utils": "static-1.4463",
      "HubStyleTokens": "static-2.11962",
      "I18n": "static-7.1708",
      "jasmine-runner": "static-1.6926",
      "quartz": "static-1.7659",
      "react": "static-7.203",
      "reselect": "static-3.16",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.518",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6631",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "moment": "static-3.75",
      "customer-data-email": "static-1.18642",
      "cv-backend-services": "static-1.1607",
      "hub-http": "static-1.6681",
      "immutable": "static-2.91",
      "immutable-less": "static-1.5127",
      "quartz-config": "static-1.1437",
      "quartz-core": "static-1.6878",
      "transmute": "static-2.97",
      "HeadJS": "static-2.822",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8749",
      "framer-motion": "static-1.84",
      "hs-test-utils-bend-plugin": "static-1.3624",
      "msw": "static-1.102",
      "msw-config": "static-1.29",
      "react-redux": "static-7.84",
      "redux": "static-4.84",
      "testing-library": "static-1.164",
      "foundations-theming": "static-1.4962",
      "i18n-data": "static-1.234",
      "metrics-js": "static-1.10110",
      "moment-timezone": "static-5.96",
      "react-utils": "static-2.5657",
      "jasmine": "static-4.4782",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3359",
      "react-aria": "static-1.77",
      "styled-components": "static-2.104",
      "UIComponents": "static-3.8908",
      "visitor-ui-component-library-icons": "static-1.6442",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5062",
      "apollo-stack-hubspot": "static-3.99",
      "classnames": "static-2.10",
      "cssUtils": "static-1.1097",
      "customer-data-objects": "static-1.8177",
      "customer-data-ui-utilities": "static-1.10308",
      "data-fetching-client": "static-1.10115",
      "FileManagerCore": "static-1.40341",
      "FileManagerLib": "static-1.40482",
      "foundations-assets": "static-1.5360",
      "graphql": "static-1.93",
      "hs-promise-utils": "static-1.6067",
      "hubspot-apollo-client": "static-1.5355",
      "icons": "static-2.702",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.118",
      "react-virtualized": "static-2.112",
      "rpc-client-utils": "static-1.5144",
      "salesImages": "static-1.732",
      "timezone-utils": "static-2.5704",
      "ui-gdpr-components": "static-1.10656",
      "ts-schema": "static-1.4393",
      "hs-locale-management": "static-1.401",
      "hs-lodash": "static-4.45",
      "immer": "static-1.105",
      "opentelemetry-fe-types": "static-1.266",
      "dispatcher": "static-1.147",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.907",
      "hubspotter-http": "static-1.4976",
      "mobile-manifest-mixins": "static-1.606",
      "module-federation": "static-1.38",
      "opentelemetry-fe": "static-1.641",
      "quartz-auth": "static-1.1334",
      "quartz-head": "static-1.1324",
      "quartz-i18n": "static-1.1334",
      "quartz-routing": "static-1.1089",
      "quartz-test": "static-1.1334",
      "quartz-tracking": "static-1.1038",
      "quick-fetch": "static-1.4231",
      "react-rhumb": "static-1.17209",
      "trellis-components": "static-1.3106",
      "ui-fonts": "static-1.1224",
      "usage-tracker-container": "static-1.7788",
      "usage-tracker-core": "static-1.7648",
      "bend-plugin-foundations-components": "static-1.5018",
      "floating-ui": "static-1.68",
      "foundations-theming-specialty": "static-1.2678",
      "hs-story-utils": "static-1.9899",
      "react-create-root-preference": "static-1.103",
      "tanstack-table": "static-1.66",
      "trellis-assets": "static-1.3087",
      "ui-images": "static-2.1276",
      "bender-build-tools": "static-1.3582",
      "bend-plugin-foundations-theming": "static-1.3445",
      "foundations-theming-base": "static-1.3947",
      "stylex": "static-1.46",
      "beacon-keepalive-queue": "static-1.175",
      "bend-plugin-metrics-js": "static-1.87",
      "HubStyle": "static-2.12269",
      "sassPrefix": "static-1.363",
      "inbound-db-properties-service-client": "static-1.4152",
      "property-translator": "static-1.5854",
      "react-dnd-compat": "static-1.5084",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.10018",
      "audio-components": "static-1.6571",
      "breeze-artifacts-sdk": "static-1.950",
      "ContentUtils": "static-1.69473",
      "copilot-toolkit": "static-1.12148",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.30062",
      "file-manager-components": "static-1.24842",
      "FileManagerImages": "static-1.37993",
      "foundations-components-legacy": "static-1.1774",
      "html-to-image": "static-1.65",
      "immerable": "static-1.4616",
      "react-colorpicker": "static-2.10684",
      "redux-toolkit": "static-1.82",
      "ui-universal-auth": "static-1.9744",
      "urlinator": "static-1.4989",
      "usage-tracker": "static-1.7798",
      "video-components": "static-1.14432",
      "video-data-lib": "static-1.36088",
      "video-embed": "static-1.36922",
      "redux-thunk": "static-2.84",
      "hubspot-apollo-cache": "static-1.814",
      "bend-plugin-chirp-manifest": "static-1.554",
      "chirp-fetch": "static-1.2379",
      "opentelemetry-web": "static-1.22",
      "hub-http-shared-msw-handlers": "static-1.10903",
      "hubspotter-http-shared-msw-handlers": "static-1.10901",
      "usage-tracker-session-replay": "static-1.5484",
      "web-vitals": "static-1.19",
      "base-ui": "static-1.27",
      "react-day-picker": "static-1.15",
      "trellis-theming": "static-1.1479",
      "tanstack-virtual": "static-1.43",
      "stylex-utils": "static-1.175",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.23885",
      "customer-data-objects-ui-components": "static-1.13510",
      "sanitize": "static-1.4949",
      "sanitize-text": "static-1.8632",
      "content-assistance-lib": "static-1.8423",
      "breeze-engine-core": "static-1.1458",
      "cms-field-types": "static-1.5285",
      "content-icons-ui": "static-1.2456",
      "integrations-lib": "static-1.17430",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.2180",
      "magpie-lib": "static-1.5907",
      "magpie-types": "static-1.5367",
      "simple-logging-lib": "static-1.3525",
      "superstore": "static-1.5234",
      "nudge-client-utils": "static-1.3420",
      "poll-commands": "static-1.3952",
      "ui-addon-iframeable": "static-1.9549",
      "video-components-external": "static-1.12430",
      "custom-vendor-connection-lib": "static-1.308",
      "unified-auth-core-lib": "static-1.1540",
      "social-insights-client-types": "static-1.22930",
      "SharedI18nStrings": "static-1.187",
      "outpost": "static-1.4602",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "atom": "static-1.5547",
      "avatar-components": "static-1.2962",
      "reference-resolvers": "static-1.8658",
      "ui-addon-video-player": "static-1.9098",
      "ui-coaching-tips": "static-1.29583",
      "flux-actions": "static-1.380",
      "frontend-preferences-client": "static-1.8395",
      "integrations-error-boundary-lib": "static-1.14845",
      "integrations-tracking-lib": "static-1.6094",
      "laboratory-lib": "static-3.7621",
      "native-integrations-shared-strings": "static-1.8238",
      "redux-observable": "static-1.79",
      "ReduxMessenger": "static-2.10845",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11620",
      "ui-shepherd-react": "static-3.10753",
      "ably": "static-2.2",
      "batch-promise": "static-1.2022",
      "breeze-engine-chat-components": "static-1.1158",
      "highlight.js": "static-1.90",
      "pulse": "static-1.1121",
      "idb-keyval": "static-1.55",
      "reactive-lib": "static-1.1193",
      "nudge-custom-function-registry": "static-1.3177",
      "nudge-renderer-utils": "static-1.3496",
      "onboarding-tours": "static-1.17405",
      "whisper-core-api": "static-1.7636",
      "navigation-messaging": "static-1.8494",
      "content-media-composition-data-lib": "static-1.13592",
      "content-media-compositions": "static-2.17599",
      "media-bridge-lib": "static-1.19643",
      "codemirror": "static-5.106",
      "fsm": "static-1.4232",
      "react-codemirror": "static-1.11116",
      "trellis-migration-context": "static-1.54",
      "growth-onboarding-feedback-components": "static-1.7057",
      "universal-page-editor-lib": "static-1.3484",
      "foundations-components-test-utils": "static-1.6232",
      "bend-plugin-pulse": "static-1.624",
      "event-emitter": "static-1.1436",
      "fast-json-patch": "static-1.74",
      "getting-started-shared-tasks": "static-1.19562",
      "growth-data-modal": "static-1.6134",
      "growth-onboarding-confetti": "static-1.3533",
      "growth-onboarding-next-action-utils": "static-1.2984",
      "navigation-components": "static-1.19167",
      "nest": "static-1.709",
      "onboarding-tours-client": "static-1.5620",
      "onboarding-tours-utils": "static-1.1472",
      "ui-shepherd-tracker": "static-1.8134",
      "user-context": "static-1.5528",
      "nav-meta": "static-1.30804",
      "js-cookie": "static-1.18",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "crm-record-cards-service-types": "static-1.3871",
      "framework-data-schema-resolvers": "static-1.7366",
      "location-customization-utils-lib": "static-1.10419",
      "onboarding-data-sync-lib": "static-1.2840",
      "growth-onboarding-next-action-components": "static-1.3012",
      "user-context-client": "static-1.4984",
      "getting-started-shared-tasks-store": "static-1.18680",
      "conditional-properties-service-client": "static-1.4114",
      "crm-pipelines-api-client-types": "static-1.4444",
      "fdsr-migration-layer": "static-1.485",
      "framework-builder-read-service-client": "static-1.4335",
      "framework-data-schema-quick-fetch": "static-1.7271",
      "inbound-db-meta-service-client": "static-1.3775",
      "multi-currency-client-types": "static-1.4008",
      "persist-promise": "static-1.4179",
      "InboxConnectUtils": "static-4.15844",
      "meetings-connect-utils-lib": "static-1.8093",
      "onboarding-scopes": "static-1.6927",
      "hub-http-contrib": "static-1.3506",
      "ui-addon-sales-email": "static-1.5676"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.28689",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13628",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8513",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4463",
      "HubStyleTokens": "/HubStyleTokens/static-2.11962",
      "I18n": "/I18n/static-7.1708",
      "jasmine-runner": "/jasmine-runner/static-1.6926",
      "quartz": "/quartz/static-1.7659",
      "react": "/react/static-7.203",
      "reselect": "/reselect/static-3.16",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.518",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6631",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "moment": "/moment/static-3.75",
      "customer-data-email": "/customer-data-email/static-1.18642",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "hub-http": "/hub-http/static-1.6681",
      "immutable": "/immutable/static-2.91",
      "immutable-less": "/immutable-less/static-1.5127",
      "quartz-config": "/quartz-config/static-1.1437",
      "quartz-core": "/quartz-core/static-1.6878",
      "transmute": "/transmute/static-2.97",
      "HeadJS": "/HeadJS/static-2.822",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8749",
      "framer-motion": "/framer-motion/static-1.84",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3624",
      "msw": "/msw/static-1.102",
      "msw-config": "/msw-config/static-1.29",
      "react-redux": "/react-redux/static-7.84",
      "redux": "/redux/static-4.84",
      "testing-library": "/testing-library/static-1.164",
      "foundations-theming": "/foundations-theming/static-1.4962",
      "i18n-data": "/i18n-data/static-1.234",
      "metrics-js": "/metrics-js/static-1.10110",
      "moment-timezone": "/moment-timezone/static-5.96",
      "react-utils": "/react-utils/static-2.5657",
      "jasmine": "/jasmine/static-4.4782",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3359",
      "react-aria": "/react-aria/static-1.77",
      "styled-components": "/styled-components/static-2.104",
      "UIComponents": "/UIComponents/static-3.8908",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6442",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5062",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.1097",
      "customer-data-objects": "/customer-data-objects/static-1.8177",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10308",
      "data-fetching-client": "/data-fetching-client/static-1.10115",
      "FileManagerCore": "/FileManagerCore/static-1.40341",
      "FileManagerLib": "/FileManagerLib/static-1.40482",
      "foundations-assets": "/foundations-assets/static-1.5360",
      "graphql": "/graphql/static-1.93",
      "hs-promise-utils": "/hs-promise-utils/static-1.6067",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5355",
      "icons": "/icons/static-2.702",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.118",
      "react-virtualized": "/react-virtualized/static-2.112",
      "rpc-client-utils": "/rpc-client-utils/static-1.5144",
      "salesImages": "/salesImages/static-1.732",
      "timezone-utils": "/timezone-utils/static-2.5704",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
      "ts-schema": "/ts-schema/static-1.4393",
      "hs-locale-management": "/hs-locale-management/static-1.401",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.105",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.266",
      "dispatcher": "/dispatcher/static-1.147",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.907",
      "hubspotter-http": "/hubspotter-http/static-1.4976",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
      "module-federation": "/module-federation/static-1.38",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.641",
      "quartz-auth": "/quartz-auth/static-1.1334",
      "quartz-head": "/quartz-head/static-1.1324",
      "quartz-i18n": "/quartz-i18n/static-1.1334",
      "quartz-routing": "/quartz-routing/static-1.1089",
      "quartz-test": "/quartz-test/static-1.1334",
      "quartz-tracking": "/quartz-tracking/static-1.1038",
      "quick-fetch": "/quick-fetch/static-1.4231",
      "react-rhumb": "/react-rhumb/static-1.17209",
      "trellis-components": "/trellis-components/static-1.3106",
      "ui-fonts": "/ui-fonts/static-1.1224",
      "usage-tracker-container": "/usage-tracker-container/static-1.7788",
      "usage-tracker-core": "/usage-tracker-core/static-1.7648",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5018",
      "floating-ui": "/floating-ui/static-1.68",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2678",
      "hs-story-utils": "/hs-story-utils/static-1.9899",
      "react-create-root-preference": "/react-create-root-preference/static-1.103",
      "tanstack-table": "/tanstack-table/static-1.66",
      "trellis-assets": "/trellis-assets/static-1.3087",
      "ui-images": "/ui-images/static-2.1276",
      "bender-build-tools": "/bender-build-tools/static-1.3582",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3445",
      "foundations-theming-base": "/foundations-theming-base/static-1.3947",
      "stylex": "/stylex/static-1.46",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.175",
      "bend-plugin-metrics-js": "/bend-plugin-metrics-js/static-1.87",
      "HubStyle": "/HubStyle/static-2.12269",
      "sassPrefix": "/sassPrefix/static-1.363",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4152",
      "property-translator": "/property-translator/static-1.5854",
      "react-dnd-compat": "/react-dnd-compat/static-1.5084",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.10018",
      "audio-components": "/audio-components/static-1.6571",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.950",
      "ContentUtils": "/ContentUtils/static-1.69473",
      "copilot-toolkit": "/copilot-toolkit/static-1.12148",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.30062",
      "file-manager-components": "/file-manager-components/static-1.24842",
      "FileManagerImages": "/FileManagerImages/static-1.37993",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1774",
      "html-to-image": "/html-to-image/static-1.65",
      "immerable": "/immerable/static-1.4616",
      "react-colorpicker": "/react-colorpicker/static-2.10684",
      "redux-toolkit": "/redux-toolkit/static-1.82",
      "ui-universal-auth": "/ui-universal-auth/static-1.9744",
      "urlinator": "/urlinator/static-1.4989",
      "usage-tracker": "/usage-tracker/static-1.7798",
      "video-components": "/video-components/static-1.14432",
      "video-data-lib": "/video-data-lib/static-1.36088",
      "video-embed": "/video-embed/static-1.36922",
      "redux-thunk": "/redux-thunk/static-2.84",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.814",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.554",
      "chirp-fetch": "/chirp-fetch/static-1.2379",
      "opentelemetry-web": "/opentelemetry-web/static-1.22",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10903",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10901",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5484",
      "web-vitals": "/web-vitals/static-1.19",
      "base-ui": "/base-ui/static-1.27",
      "react-day-picker": "/react-day-picker/static-1.15",
      "trellis-theming": "/trellis-theming/static-1.1479",
      "tanstack-virtual": "/tanstack-virtual/static-1.43",
      "stylex-utils": "/stylex-utils/static-1.175",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.23885",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13510",
      "sanitize": "/sanitize/static-1.4949",
      "sanitize-text": "/sanitize-text/static-1.8632",
      "content-assistance-lib": "/content-assistance-lib/static-1.8423",
      "breeze-engine-core": "/breeze-engine-core/static-1.1458",
      "cms-field-types": "/cms-field-types/static-1.5285",
      "content-icons-ui": "/content-icons-ui/static-1.2456",
      "integrations-lib": "/integrations-lib/static-1.17430",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2180",
      "magpie-lib": "/magpie-lib/static-1.5907",
      "magpie-types": "/magpie-types/static-1.5367",
      "simple-logging-lib": "/simple-logging-lib/static-1.3525",
      "superstore": "/superstore/static-1.5234",
      "nudge-client-utils": "/nudge-client-utils/static-1.3420",
      "poll-commands": "/poll-commands/static-1.3952",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9549",
      "video-components-external": "/video-components-external/static-1.12430",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.308",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1540",
      "social-insights-client-types": "/social-insights-client-types/static-1.22930",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
      "outpost": "/outpost/static-1.4602",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "atom": "/atom/static-1.5547",
      "avatar-components": "/avatar-components/static-1.2962",
      "reference-resolvers": "/reference-resolvers/static-1.8658",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9098",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29583",
      "flux-actions": "/flux-actions/static-1.380",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8395",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14845",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6094",
      "laboratory-lib": "/laboratory-lib/static-3.7621",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8238",
      "redux-observable": "/redux-observable/static-1.79",
      "ReduxMessenger": "/ReduxMessenger/static-2.10845",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11620",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10753",
      "ably": "/ably/static-2.2",
      "batch-promise": "/batch-promise/static-1.2022",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1158",
      "highlight.js": "/highlight.js/static-1.90",
      "pulse": "/pulse/static-1.1121",
      "idb-keyval": "/idb-keyval/static-1.55",
      "reactive-lib": "/reactive-lib/static-1.1193",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3177",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3496",
      "onboarding-tours": "/onboarding-tours/static-1.17405",
      "whisper-core-api": "/whisper-core-api/static-1.7636",
      "navigation-messaging": "/navigation-messaging/static-1.8494",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13592",
      "content-media-compositions": "/content-media-compositions/static-2.17599",
      "media-bridge-lib": "/media-bridge-lib/static-1.19643",
      "codemirror": "/codemirror/static-5.106",
      "fsm": "/fsm/static-1.4232",
      "react-codemirror": "/react-codemirror/static-1.11116",
      "trellis-migration-context": "/trellis-migration-context/static-1.54",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7057",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3484",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6232",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.624",
      "event-emitter": "/event-emitter/static-1.1436",
      "fast-json-patch": "/fast-json-patch/static-1.74",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19562",
      "growth-data-modal": "/growth-data-modal/static-1.6134",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3533",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2984",
      "navigation-components": "/navigation-components/static-1.19167",
      "nest": "/nest/static-1.709",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5620",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1472",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8134",
      "user-context": "/user-context/static-1.5528",
      "nav-meta": "/nav-meta/static-1.30804",
      "js-cookie": "/js-cookie/static-1.18",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7366",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10419",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2840",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3012",
      "user-context-client": "/user-context-client/static-1.4984",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18680",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4114",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4444",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.485",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4335",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7271",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3775",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.4008",
      "persist-promise": "/persist-promise/static-1.4179",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15844",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8093",
      "onboarding-scopes": "/onboarding-scopes/static-1.6927",
      "hub-http-contrib": "/hub-http-contrib/static-1.3506",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5676"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.28689",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};